<div (mousemove)="extendSession()" (keydown)="extendSession()" (scroll)="extendSession()">
    <button id="openRefreshModalButton" [hidden]="true" data-toggle="modal" data-target="#refreshsessionmodal">Open Modal</button>
    <!-- show refresh session modal -->
    <div
    class="modal fade"
    id="refreshsessionmodal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="refreshsessionmodalLabel"
    
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
    <app-refreshsession></app-refreshsession>
    </div>
    </div>
<app-top-nav></app-top-nav>
<div class="container-fluid">
    <app-loader></app-loader>
    <app-orgswitcher></app-orgswitcher>
    <div class="row flex-nowrap">
        <div [ngClass]="{'col-lg-8': showChat}" class="col pr-0 pl-0">
            <router-outlet></router-outlet>
        </div>
    <div *ngIf="showChat" id="chatcollapsecontrol" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-2 pr-0 pl-0">
            <app-footer [mobilefooter]="true"></app-footer>
        </div>
    </div>
</div>
    <app-footer-mobile-nav></app-footer-mobile-nav>
<!-- <button #openchat style="visibility: hidden;" class="d-none btn btn-primary" data-toggle="collapse" data-target="#chatcollapsecontrol">
</button> -->
</div>